import { Theme } from '@material-ui/core';

export const CIRCLE_RADIUS = 10;
export const STROKE_WIDTH = 2;
export const ICON_PADDING = 1;
export const ICON_VIEWBOX = '0 0 24 24';

export const getColorsClasses = (theme: Theme) => ({
  warningColor: {
    color: theme.palette.warning.main,
  },
  primaryColor: {
    color: theme.palette.primary.main,
  },
  secondaryColor: {
    color: theme.palette.secondary.main,
  },
  infoColor: {
    color: theme.palette.info.main,
  },
  errorColor: {
    color: theme.palette.error.main,
  },
  successColor: {
    color: theme.palette.success.main,
  },
  inheritColor: {
    color: 'inherit',
  },
});
